"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCategory = exports.OrderBackStatus = exports.OrderFrontStatus = void 0;
var OrderFrontStatus;
(function (OrderFrontStatus) {
    OrderFrontStatus["validated"] = "validated";
    OrderFrontStatus["payed"] = "payed";
    OrderFrontStatus["preparation"] = "preparation";
    OrderFrontStatus["delivered"] = "delivered";
    OrderFrontStatus["refunded"] = "refunded";
    OrderFrontStatus["paiement_failed_can_not_resume"] = "paiement_failed_can_not_resume";
    OrderFrontStatus["paiement_failed_can_resume"] = "paiement_failed_can_resume";
    OrderFrontStatus["paiement_3ds"] = "paiement_3ds";
    OrderFrontStatus["canceled_can_resume"] = "canceled_can_resume";
    OrderFrontStatus["canceled_can_not_resume"] = "canceled_can_not_resume";
})(OrderFrontStatus || (exports.OrderFrontStatus = OrderFrontStatus = {}));
var OrderBackStatus;
(function (OrderBackStatus) {
    OrderBackStatus["shipped"] = "S";
    OrderBackStatus["cancelled"] = "X";
    OrderBackStatus["pending"] = "P";
    OrderBackStatus["subscription"] = "A";
})(OrderBackStatus || (exports.OrderBackStatus = OrderBackStatus = {}));
var PriceCategory;
(function (PriceCategory) {
    PriceCategory["priceOneShot"] = "priceOneShot";
    PriceCategory["priceOneShotEnterprise"] = "priceOneShotEnterprise";
    PriceCategory["priceSubscription"] = "priceSubscription";
    PriceCategory["priceSubscriptionEnterprise"] = "priceSubscriptionEnterprise";
})(PriceCategory || (exports.PriceCategory = PriceCategory = {}));
exports.default = {
    OrderFrontStatus: OrderFrontStatus,
    OrderBackStatus: OrderBackStatus,
    PriceCategory: PriceCategory,
};
//# sourceMappingURL=Order.js.map